








































































/** У магазина ровно один аудитор: выбор нового переносит связку, а не добавляет второго */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import MmAuditorSelect from '../../components/MmAuditorSelect.vue';
import MmHintedButton from '../../components/MmHintedButton.vue';
import { MmAuditor, MmStoreAuditorAssignment } from '../../types/domain';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.assignments.';

@Component({
	components: { MmAuditorSelect, MmHintedButton },
})
export default class AssignmentAuditorCell extends Vue {
	@Prop({ required: true }) readonly row!: MmStoreAuditorAssignment;

	/** Справочник грузится экраном один раз и беден: заполнены только id, логин и ФИО */
	@Prop({ default: () => [] }) readonly options!: MmAuditor[];

	@Prop({ default: false }) readonly editing!: boolean;

	@Prop({ default: false }) readonly saving!: boolean;

	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: '' }) readonly disabledReason!: string;

	pendingAuditorId: number | string | null = null;

	/** Значение берём из справочника: a-select сравнивает строго, число и строка не совпадут */
	get currentAuditorId(): number | string | null {
		const raw = this.row && this.row.auditorId != null ? this.row.auditorId : null;

		if (raw === null || String(raw).trim() === '') {
			return null;
		}

		const list = this.options ? this.options : [];

		for (let i = 0; i < list.length; i += 1) {
			if (list[i] != null && this.sameAuditorId(list[i].id, raw)) {
				return list[i].id;
			}
		}

		return null;
	}

	get login(): string {
		return this.row && this.row.auditorLogin ? String(this.row.auditorLogin).trim() : '';
	}

	get fullName(): string {
		return this.row && this.row.auditorFullName ? String(this.row.auditorFullName).trim() : '';
	}

	/** Назначенность считаем по логину, а не по идентификатору: пустой логин дал бы пустую ячейку */
	get hasAuditor(): boolean {
		return this.login !== '';
	}

	get unassignedText(): string {
		return this.$t(KEY_PREFIX + 'unassignedPlaceholder') as string;
	}

	get editHint(): string {
		return this.$t(KEY_PREFIX + 'editAuditorTitle') as string;
	}

	get confirmHint(): string {
		return this.$t(KEY_PREFIX + 'confirmAuditor') as string;
	}

	get cancelHint(): string {
		return this.$t(KEY_PREFIX + 'cancelAuditorEdit') as string;
	}

	get isDirty(): boolean {
		return !this.sameAuditorId(this.pendingAuditorId, this.currentAuditorId);
	}

	@Watch('editing', { immediate: true })
	onEditingChanged(next: boolean): void {
		if (next) {
			this.pendingAuditorId = this.currentAuditorId;
			this.emitDirty(false);
		}
	}

	/** Проверка нужна и здесь: a-tooltip оборачивает отключённую кнопку, и клик всё равно всплывает */
	handleStartEdit(): void {
		if (this.disabled || this.editing) {
			return;
		}

		this.$emit('start-edit');
	}

	handleChange(auditorId: number | string | null): void {
		if (this.saving) {
			return;
		}

		this.pendingAuditorId = auditorId;
		this.emitDirty(this.isDirty);
	}

	handleConfirm(): void {
		if (this.saving) {
			return;
		}

		this.$emit('confirm', this.pendingAuditorId);
	}

	handleCommitClick(): void {
		this.handleConfirm();
	}

	handleCancel(): void {
		this.pendingAuditorId = this.currentAuditorId;
		this.emitDirty(false);
		this.$emit('cancel');
	}

	handleRevertClick(): void {
		this.handleCancel();
	}

	handleNav(direction: string): void {
		if (this.isDirty) {
			return;
		}

		this.$emit('nav', direction);
	}

	private emitDirty(isDirty: boolean): void {
		this.$emit('dirty', isDirty === true);
	}

	/** Сравниваем строками: боевой id — UUID, Number даёт NaN; ветка null стоит до приведения */
	private sameAuditorId(left: number | string | null, right: number | string | null): boolean {
		if (left == null && right == null) {
			return true;
		}

		if (left == null || right == null) {
			return false;
		}

		return String(left) === String(right);
	}
}
